<template>
    <Section
        width="sm"
        :label="slice.slice_label"
    >
        <HeaderSection 
            :header="slice.primary.h2" 
            :teaser="slice.primary.text" 
        />        
        <div class="grid">
            <div
                v-for="(item, index) in slice.items"
                :key="index"
                class="grid-item rich-text"
                :class="{'image-item': !showSteps && showImage}"
            >
                <span v-if="showSteps">{{ index+1 }}</span>

                <PrismicImage
                    v-else-if="showImage"
                    :img="item.image1"
                    :w="item.image1?.dimensions?.width < 350 ? item.image1.dimensions.width : '350'"
                />
                <div v-else class="icons">
                    <i class="fa-solid fa-chevrons-right" />
                </div>
                <div
                    class="grid-item__content"
                    v-html="$prismic.asHtml(item.text)"
                />
            </div>
        </div>
    </Section>
</template>

<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    computed: {
        showSteps() {
            return this.slice.primary.show_steps;
        },
        showImage() {
            return this.slice.items
                .some(item => item.image1.url);
        }
    }
};
</script>

<style lang="scss" scoped>
section::v-deep {
    .grid {
        @include grid(1, 20px);

        h2,
        h3,
        h4,
        h5 {
            margin-bottom: 20px;
            @include font-size(22px);
        }

        &-item {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            @include device(pad) {
                gap: 1rem;
            }
            &__content {
                @include device(pad) {
                    padding-top: 0.5rem;
                }
            }
            &.image-item {
                flex-direction: column;
                @include device(pad) {
                    flex-direction: row;
                }
            }

            p:first-child {
                margin-top: 0;
            }

            span {
                align-self: flex-start;
                font-family: $fontHeader;
                color: $pink;
                @include font-size(32px, 0);

                @include device(pad) {
                    @include font-size(44px, 0);
                }
            }
        }
    }
    &:has(.icons) {
        .grid-item {
            align-items: baseline;
        }
    }
}
</style>